import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import Styles from './YearSelector.module.css';

const YearView = ({ qualYear, previousYears, futureYears, yearList, fixedYear, updateYear, selectedYear }) => (
	<div className={Styles.container}>
		<Typography id="year-selector-label" variant="subtitle1" component="span" htmlFor="year-selector">Year: </Typography>
		<div className={Styles.content}>
			{fixedYear ? (
				<Typography id="year-selector-label" variant="subtitle1" component="label" htmlFor="year-selector">{qualYear}</Typography>
			) : (
				<Select id="year-selector" value={selectedYear} onChange={updateYear} displayEmpty>
					<MenuItem value="" disabled>Select</MenuItem>
					{previousYears.map((year) =>
						<MenuItem key={year} value={year}>{year}</MenuItem>)}
					{yearList.map((year) =>
						<MenuItem key={year} value={year}>{year}</MenuItem>)}
					<MenuItem value={qualYear}>{qualYear}</MenuItem>
					{futureYears.map((year) =>
                        <MenuItem key={year} value={year}>{year}</MenuItem>)}

				</Select>
			)}
		</div>
	</div>
);
YearView.propTypes = {
	qualYear: PropTypes.string.isRequired,
	previousYears: PropTypes.array,
	futureYears: PropTypes.array,
	fixedYear: PropTypes.bool,
	updateYear: PropTypes.func.isRequired,
	selectedYear: PropTypes.string,
	yearList: PropTypes.array
};

export default YearView;
